export const ENV = process.env.NODE_ENV;
export const TG_TOKEN = process.env.REACT_APP_TELEGRAM_TOKEN;
export const TG_CHAT_ID = process.env.REACT_APP_TELEGRAM_CHAT;
export const TG_POST_URL = `https://api.telegram.org/bot${TG_TOKEN}/sendMessage`;
